import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets/index.js';
import { createServiceProvider } from '../util/index.js';

export default createServiceProvider({
  ...getServiceProvider('gorgias'),
  avatarPath: avatars.gorgias,
  logoPath: logos.gorgias
});
